/**
 * @namespace Utils
 * @category Utils
 * @module Cache */

import localforage from 'localforage'

localforage.config({
  //driver      : localforage.WEBSQL, // Force WebSQL; same as using setDriver()
  name: 'geored_v3',
  version: 1.0,
  //size        : 4980736, // Size of database, in bytes. WebSQL-only for now.
  //storeName   : 'keyvaluepairs', // Should be alphanumeric, with underscores.
  //description : 'some description'
})

export default {
  ...localforage,
  async setItem(key, value) {
    return localforage.setItem(key, value)
  },
  async getItem(key) {
    return localforage.getItem(key)
  },
  async removeItem(key) {
    return localforage.removeItem(key)
  },
  async exists(key) {
    let keys = await localforage.keys()
    return keys.includes(key)
  },
}

/**
 * LocalStorage simple wrapper with prefix support.
 * @param {*} PREFIX
 * @returns
 */
export function createLocalStorageSimpleWrapper(PREFIX = '') {
  if (!PREFIX) {
    throw new Error('createLocalStorageSimpleWrapper: PREFIX required')
  }
  return {
    set(name, value) {
      localStorage.setItem(PREFIX + name, value)
    },

    get(name) {
      return localStorage.getItem(PREFIX + name)
    },

    remove(name) {
      localStorage.removeItem(PREFIX + name)
    },
    /**
     * Clear all the kys from localStorage with prefix v3env_
     */
    clearAll() {
      const keys = Object.keys(localStorage).filter((key) =>
        key.startsWith(PREFIX)
      )

      keys.forEach((key) => {
        localStorage.removeItem(key)
      })
    },

    checkIfExists(name) {
      return localStorage.getItem(PREFIX + name) !== null
    },

    getAll() {
      const keys = Object.keys(localStorage).filter((key) =>
        key.startsWith(PREFIX)
      )

      return keys.reduce((obj, key) => {
        obj[key.replace(PREFIX, '')] = localStorage.getItem(key)
        return obj
      }, {})
    },
  }
}
